module["exports"] = [
  "#####",
  "#####-###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/address/postcode.js
// module id = 1592
// module chunks = 0